import Guid from "./Guid"
import IReservationDetail from "./IReservationDetail";
import IReservationAge from "./IReservationAge";
import IReservationEquipement from "./IReservationEquipement";
import IReservationDetailOccupant from "./IReservationDetailOccupant";
import IOptionReservation from "./OptionReservation";

export enum ReservationDetailSommaireTypeAuxiliaire {
    Aucun = "",
    Unite = "UN",
    Produit = "PR"
}

export default interface IReservationDetailSommaire {
    idReservationDetailSommaire?: Guid,
    idReservationEntete: Guid,
    typeAuxiliaire: string,
    idAuxiliaire: Guid,
    dateDebut?: Date,
    dateFin?: Date,
    nombreJours: number | "",
    montant: number
    dateCreation: Date,
    dateModification: Date,
    dateSuppression?: Date,
    idUsagerCreation?: Guid,
    idUsagerModification?: Guid,
    idUsagerSuppression?: Guid,
    genereAuto: boolean,
    idClient: Guid,
    idTypeAuxiliaire?: Guid,
    reservationDetails: IReservationDetail[],
    reservationAges: IReservationAge[],
    reservationDetailOccupants: IReservationDetailOccupant[]
    reservationDetailEquipements: IReservationEquipement,
    isDeleted: boolean,
    optionReservations?: IOptionReservation[]
}